import { Autocomplete, FormControl, InputLabel, TextField } from '@mui/material'
import { Dispatch, RefObject, useState } from 'react'

import { FormInput } from '../../../lib/workout-form/transformers'
import { useWorkoutSettings } from '../../../providers/workout-settings'
import { Action, FormInputs } from '../../../reducers/workoutReducer'

type Props = {
  dispatch: Dispatch<Action>
  loading: boolean
  location: FormInput
  handleErrorRefs: RefObject<(() => void)[]>
}

const LocationInput = ({
  handleErrorRefs,
  dispatch,
  loading,
  location,
}: Props) => {
  const [error, setError] = useState(false)
  const [message, setMessage] = useState('')
  const { activeLocations } = useWorkoutSettings()

  const handleError = () => {
    setError(location.error)
    setMessage(location.message)
  }

  handleErrorRefs.current?.push(handleError)

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel htmlFor="location" error={error}></InputLabel>
      <Autocomplete
        freeSolo
        disabled={loading}
        options={activeLocations.map((location) => location.name)}
        value={(location.input as string) ?? ''}
        onChange={(_, value) =>
          dispatch({ type: FormInputs.location, payload: value ?? '' })
        }
        onInputChange={(_, value) =>
          dispatch({ type: FormInputs.location, payload: value })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            id="location"
            label="Plats"
            maxRows={4}
            onBlur={handleError}
            error={error}
            helperText={message}
          />
        )}
      />
    </FormControl>
  )
}

export default LocationInput
